"use client";
import { createContext, useContext } from "react";
import { CategorySinglePageProps } from "@/types/strapi/category";

export type CategorySinglePageContextType = CategorySinglePageProps | null;

export const CategorySinglePageContext = createContext<CategorySinglePageContextType>(null);

export const useCategorySinglePageContext = () => useContext(CategorySinglePageContext);
